export const resolveRiskValue = (...values) => {
  for (let value of values) {
    if (value !== null && value !== undefined) {
      return Math.round(Number(value));
    }
  }
  return 0;
};
export const getRiskLevelClass = (risk = 0) => {
  const base = "card__product__number";

  if (risk >= 65) return { className: `${base} card__product__green` };
  if (risk >= 31) return { className: `${base} card__product__yellow` };
  if (risk > 0) return { className: `${base} card__product__red` };

  return { className: `${base} card__product__white` };
};

const BASE_CIRCLE_PROPS = {
  fontSize: "1.625em",
  fontWeight: 900,
  boxShadow: "inset 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 16%)",
  unit: "",
  textPosition: "0.35em",
  animationOff: false,
  inverse: false,
  round: true,
  number: false,
};

const createCircleProps = (percent, color, size) => ({
  ...BASE_CIRCLE_PROPS,
  percent: Math.round(percent ?? 0),
  colorSlice: color,
  fontColor: color,
  size: size,
});

export const renderClassName = (productRisk, color, size) => {
  const coldProps = createCircleProps(productRisk, "#4DC7B5", size);
  const riskProps = createCircleProps(productRisk, "#EFB661", size);
  const holdProps = createCircleProps(productRisk, "#F27281", size);
  const whiteProps = createCircleProps(0, "#C4C4C4");
  switch (color) {
    case "green":
      return {
        className: "card cold defi",
        props: coldProps,
      };
    case "yellow":
      return {
        className: "card hold defi",
        props: riskProps,
      };
    case "red":
      return {
        className: "card risky defi",
        props: holdProps,
      };
    case "white":
      return {
        props: whiteProps,
        color: "#C4C4C4",
        className: "card empty defi",
      };
  }
};
